module.exports = __webpack_public_path__ + "media/bangongshi.654d308a.mp4";